import { getWebPath, TableSettingsTabType } from '@doss/common-all'
import { Settings } from 'lucide-react'
import { Link } from 'react-router'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'

export function TableMenu({ tableId }: { tableId?: string }) {
  if (!tableId) {
    return null
  }
  return (
    <Link
      className="flex cursor-pointer items-center justify-center rounded p-2 hover:bg-gray-2"
      onClick={(e) => e.stopPropagation()}
      to={getWebPath({
        objectType: BreadcrumbObjectType.TABLE,
        objectId: tableId,
        settings: true,
        settingsParams: { tab: TableSettingsTabType.FIELDS },
      })}
    >
      <Settings size={16} />
    </Link>
  )
}
